import React from 'react';
import Help from '../../components/Help';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function HelpPage() {
  return (
    <AppLayout title="Ajuda" subtitle="Suporte e documentação" fullWidth>
      <Help />
    </AppLayout>
  );
}

export default HelpPage;
